export default "__VITE_ASSET__DZcgc5BF__"